<template>
  <v-card class="mb-4" elevation="2">
    <v-card-title>Anschrift</v-card-title>
    <v-card-text>
      <v-text-field
          :value="address.companyName"
          @input="updateField('companyName', $event)"
          label="Firmenname (optional)"
          dense
      ></v-text-field>
      <v-row>
        <v-col cols="6">
          <v-text-field
              :value="address.firstname"
              @input="updateField('firstname', $event)"
              :rules="addressRules"
              label="Vorname"
              required
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
              :value="address.lastname"
              @input="updateField('lastname', $event)"
              :rules="addressRules"
              label="Nachname"
              required
              dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-text-field
              :value="address.street"
              @input="updateField('street', $event)"
              :rules="addressRules"
              label="Straße"
              required
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
              :value="address.streetNumber"
              @input="updateField('streetNumber', $event)"
              :rules="addressRules"
              label="Hausnummer"
              required
              dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-text-field
          :value="address.extra"
          @input="updateField('extra', $event)"
          label="Adresszusatz (optional)"
          dense
      ></v-text-field>
      <v-row>
        <v-col cols="4">
          <v-text-field
              :value="address.plz"
              @input="updateField('plz', $event)"
              :rules="addressRules"
              label="PLZ"
              required
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="8">
          <v-text-field
              :value="address.city"
              @input="updateField('city', $event)"
              :rules="addressRules"
              label="Stadt"
              required
              dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-text-field
          :value="address.country"
          @input="updateField('country', $event)"
          :rules="addressRules"
          label="Land"
          required
          dense
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AddressCard',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  computed: {
    addressRules() {
      return [v => !!v || 'Pflichtfeld'];
    }
  },
  methods: {
    updateField(field, value) {
      const newAddress = { ...this.address, [field]: value };
      this.$emit('update:address', newAddress);
    }
  }
}
</script>
